<template>

  <rpm-card-list
      title="Pessoas"
      :data="persons"
      :loading="tableDataIsLoading"
      @change-page="getPersons"
      :pagination="pagination"
      grid-class="lg:grid-cols-2 grid-cols-1 gap-6"
  >
    <template #badges="{ item }">
      <badge class="bg-sky-500">{{ switchPersonType(item.type) }}</badge>
    </template>

    <template #actions="{ item }">
      <rpm-button
          color="transparent"
          icon="fa-solid fa-square-up-right"
          tooltip-text="informações"
          :to="{ name: 'PeopleShow', params: { id: item.id } }"
      ></rpm-button>

      <rpm-button
          color="transparent"
          tooltip-text="editar"
          icon="fa-solid fa-pen-to-square"
          @click="setAddress(item), openModal(item)"
      ></rpm-button>

      <rpm-button
          color="transparent"
          tooltip-text="reiniciar senha"
          icon="fa-solid fa-key"
          @click="openModalResetPassword(item)"
          v-if="item.email"
      ></rpm-button>
    </template>

    <template #info="{ item }">
      <span class="font-bold text-lg capitalize"> {{ item.name }} </span>
      <span v-if="item.cpf_cnpj" class="text-sm">
        <span class="font-bold"> Cnpj / Cpf: </span>
        <span class="font-semibold"> {{ item.cpf_cnpj }} </span>
      </span>
      <span v-if="item.birthday" class="text-sm"> <b>Data de Nascimento:</b> {{ item.birthday }} </span>
      <span v-if="item.genre" class="text-sm"> <b>Gênero:</b> {{ item.genre }} </span>
      <span v-if="item.mobile" class="text-sm"> <b>Contato:</b> {{ item.mobile }} </span>
      <span v-if="item.email" class="text-sm"> <b>Email:</b> {{ item.email }} </span>
    </template>
  </rpm-card-list>

  <rpm-modal
      persist
      padding="py-10 px-8"
      header="Atualizar Pessoa"
      class="flex flex-col gap-y-12"
      :open="modalOpen"
      @close="modalOpen = false"
  >
    <div class="grid grid-cols-12 gap-x-6 gap-y-8">
      <person-form
          no-email-confirm
          :form="person"
      ></person-form>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-8">
      <address-form
          :address="person.address"
      ></address-form>
    </div>

    <div class="flex flex-row gap-x-6 items-center justify-center col-span-12">
      <rpm-button
          label="Fechar"
          color="gray"
          @click="modalOpen = false"
      ></rpm-button>

      <rpm-button
          label="Confirmar"
          color="theme"
      ></rpm-button>
    </div>
  </rpm-modal>
  <rpm-modal :open="modalConfirmResetPassword" v-if="selectedPerson">
    <p>Reiniciar senha para: {{selectedPerson.name}}</p>
    <section class="flex flex-row justify-center gap-6 mt-4">
      <rpm-button @click="resetPassword" label="Salvar" :loading="loadingPasswordReset"/>
      <rpm-button @click="modalConfirmResetPassword = false" label="Fechar" color="gray"/>
    </section>
  </rpm-modal>

</template>

<script>

import {request} from "#repositories/repository";
import personRepository from "#repositories/personRepository";
import RpmCardList from "#components/RpmCardList.vue";
import Badge from "#components/Badge.vue";
import RpmModal from "#components/RpmModal.vue";

import AddressForm from '#views/address/form';
import PersonForm from "../form";


export default {
  name: "Persons",
  components: {
    RpmCardList,
    RpmModal,
    AddressForm,
    PersonForm,
    Badge
  },
  data() {
    return {
      person: {},
      persons: [],
      tableDataIsLoading: true,
      modalOpen: false,
      pagination: {
        page: this.$route.query.page ?? 1,
        per_page: 10,
        last_page: 0,
        links: []
      },
      columns: [
        {
          field: "name",
          label: "Nome",
        },
        {
          field: "cpf_cnpj",
          label: "CPF/CNPJ",
        },
        {
          field: "birthday",
          label: "Data de nascimento",
        },
        {
          field: "genre",
          label: "Sexo",
        },
        {
          field: "mobile",
          label: "Contato",
        },
        {
          field: "email",
          label: "Email",
        },
        {
          field: "type",
          label: "Pessoa",
        },
      ],
      modalConfirmResetPassword: false,
      selectedPerson: null,
      loadingPasswordReset: false
    };
  },
  methods: {
    setAddress(item) {
      if (!item.address) item.address = {};
    },
    switchPersonType(type) {
      switch (type) {
        case 'F':
          return 'Física';
        case 'J':
          return 'Jurídica';
      }
    },
    openModalResetPassword(item) {
      this.selectedPerson = item
      this.modalConfirmResetPassword = true
    },
    resetPassword() {
      this.loadingPasswordReset = true
      personRepository.changePassword({
        email: this.selectedPerson.email,
        cpf_cnpj: this.selectedPerson.cpf_cnpj
      }).then((response) => {
        this.$notify('Email de recuperação enviado.', 'success')
        this.modalConfirmResetPassword = false
      }).catch((error) => {
        this.$notify(error.response.data, 'error')
      }).finally(() => {
        this.loadingPasswordReset = false
      })
    },
    async getPersons(page = 0) {
      if (page != 0) this.pagination.page = page;

      this.tableDataIsLoading = true;

      this.persons = request.pagination(
          await personRepository.getPersons(this.pagination),
          this.pagination
      );

      this.tableDataIsLoading = false;
    },
    openModal(item) {
      this.person = item;
      this.modalOpen = true;
    }
  },
  mounted() {
    this.getPersons();
  }
};
</script>
